<template>
  <div id="WaitingRoom">
    <div
      class="d-flex flex-column justify-content-center align-items-center py-5 my-3"
    >
      <h1 class="waiting-room-title brand-secondary pb-0">You’re early</h1>
      <div class="waiting-room-meta">
        <span class="mr-3">Service Provider: {{ booking.clinician.name }}</span>
        <span class="mr-3">|</span>
        <span>
          {{ getHoursMinutes(booking.startTime) }} -
          {{ getHoursMinutes(booking.endTime) }}
        </span>
      </div>
      <div
        class="waiting-room-video-container d-flex flex-column justify-content-center align-items-center"
      >
        <div
          class="waiting-room-video d-flex justify-content-center align-items-center"
        >
          <div class="waiting-room-countdown">
            <div class="waiting-room-counter">
              <span class="waiting-room-timer" v-if="days"
                >{{ days }} {{ days > 1 ? "days" : "day" }}</span
              >
              <span class="waiting-room-timer" v-else-if="hours !== ''"
                >{{ hours }}:{{ minutes }}:{{ seconds }}
              </span>
              <p class="waiting-room-paragraph">Until your session starts</p>
            </div>
          </div>
        </div>
      </div>
      <p class="waiting-room-message">
        Wait here for your session to start or alternatively check back closer
        to when your session is due to start.
      </p>
      <b-button class="px-5 close-button" @click="close"
        >Leave waiting room</b-button
      >
    </div>
  </div>
</template>
<script>
import {
  getAppointmentCountdownParts,
  getMillisecondsUntilAppointment
} from "@/utils/appointmentTimezone";

export default {
  props: ["booking"],
  name: "WaitingRoom",
  data() {
    return {
      isEarly: true,
      timeRemaining: "",
      intervalFunction: "",
      seconds: "",
      minutes: "",
      hours: "",
      days: ""
    };
  },
  mounted() {
    if (this.updateCountdown()) {
      this.intervalFunction = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalFunction);
  },
  methods: {
    updateCountdown() {
      const diffMs = getMillisecondsUntilAppointment(
        this.getCountdownAppointment()
      );

      if (diffMs === null) {
        return true;
      }

      if (diffMs <= 0) {
        clearInterval(this.intervalFunction);
        this.updateParentTimeout();
        return false;
      }

      const countdown = getAppointmentCountdownParts(diffMs);
      this.days = countdown.days;
      this.hours = countdown.hours;
      this.minutes = countdown.minutes;
      this.seconds = countdown.seconds;

      if (diffMs < 1500) {
        clearInterval(this.intervalFunction);
        this.updateParentTimeout();
        return false;
      }

      return true;
    },
    getCountdownAppointment() {
      return {
        startTime: this.booking?.startTime,
        endTime: this.booking?.endTime,
        startDublinMs: this.booking?.startDublinMs
      };
    },
    updateParentTimeout() {
      this.$emit("timeoutOver");
    },
    close() {
      this.$bvModal.hide("digital_clinics_modal");
    }
  }
};
</script>
<style lang="less">
#WaitingRoom {
  .waiting-room-title {
    font-family: "DMSans Bold";
    font-size: 2.2rem;
    line-height: 2.6rem;
    margin-bottom: 16px;
  }

  .waiting-room-meta {
    display: flex;
    flex-wrap: wrap;
    font-family: "DMSans Bold";
    font-size: 1.8rem;
    color: #797b89;
    line-height: 2.2rem;
    margin-bottom: 44px;
  }

  .waiting-room-video-container {
    max-width: 600px;
    width: 100%;
    aspect-ratio: 16/9;
    position: relative;
    display: flex;
    margin-bottom: 32px;

    .waiting-room-video {
      background: #1e1e22;
      width: 100%;
      flex-grow: 1;
    }
  }

  .waiting-room-counter {
    text-align: center;
    color: white;
    font-size: 1.8rem;

    .waiting-room-timer {
      font-family: "DMSans Bold";
      font-size: 4rem;
    }

    .waiting-room-paragraph {
      font-family: "DMSans Bold";
      font-size: 1.8rem;
      margin-top: 4px;
    }
  }

  .waiting-room-message {
    max-width: 600px;
    text-align: center;
    font-family: "DMSans";
    font-size: 1.4rem;
    color: #797b89;
    margin-bottom: 40px;
  }

  .close-button {
    min-width: 50%;
    font-family: "DMSans Bold";
    border: 1px solid rgba(30, 30, 34, 0.4) !important;
    padding: 20px;
    min-height: 64px;
    background-color: #1e1e22;
    border-radius: 40px !important;
    font-size: 1.6rem !important;
    color: #fff;
    letter-spacing: normal;

    &:hover,
    &:focus {
      color: #fff;
      background-color: #009577;
    }
  }
}
</style>
